var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:( _obj = { underline: _vm.underline }, _obj['link text-' + _vm.linkColor] = true, _obj ),attrs:{"variant":"link","to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }